import { union } from '@iwentsourcing/core/typing/union.js';
import { literal } from '@iwentsourcing/core/typing/literal.js';

export const SortDirection = union('SortDirection', [
  literal('prev'),
  literal('next'),
]);
